import styled from '@emotion/styled';
import { Button, Tooltip } from '@innovamat/glimmer-components';

type ClassroomElementProps = {
  text: string;
  classroomAlias: string;
  classroomId: string;
  courseOrder: number;
  goToClassroom?: (classroomId: string) => void;
};

const StyledTooltip = styled(Tooltip)`
  display: block !important;
`;

const TextWrapper = styled.p`
  max-width: 134px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ClassroomElement = ({
  text,
  classroomAlias,
  classroomId,
  courseOrder,
  goToClassroom,
}: ClassroomElementProps): JSX.Element => {
  const displayText = classroomAlias || text;
  return (
    <StyledTooltip content={text} popperOptions={{ strategy: 'fixed' }}>
      <Button
        data-testid={`${courseOrder}_${displayText}_CLASSROOMNAME`}
        rightIcon="NextWithTextIcon"
        variant="secondary"
        size="S"
        onClick={goToClassroom ? () => goToClassroom(classroomId) : undefined}
        oneLine
      >
        <TextWrapper>{displayText}</TextWrapper>
      </Button>
    </StyledTooltip>
  );
};

export default ClassroomElement;
